import _classCallCheck from "/Users/yawjosephetse/Developer/repetere/periodicjs.ext.reactapp/adminclient/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/yawjosephetse/Developer/repetere/periodicjs.ext.reactapp/adminclient/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/yawjosephetse/Developer/repetere/periodicjs.ext.reactapp/adminclient/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/yawjosephetse/Developer/repetere/periodicjs.ext.reactapp/adminclient/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/yawjosephetse/Developer/repetere/periodicjs.ext.reactapp/adminclient/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import { Component, PropTypes } from 'react';

var DataComponent =
/*#__PURE__*/
function (_Component) {
  _inherits(DataComponent, _Component);

  function DataComponent() {
    _classCallCheck(this, DataComponent);

    return _possibleConstructorReturn(this, _getPrototypeOf(DataComponent).apply(this, arguments));
  }

  _createClass(DataComponent, [{
    key: "dataProps",
    value: function dataProps() {
      var extraProps = {};

      if (typeof this.props.data !== 'undefined' && this.props.data && this.props.data.length > 0) {
        this.props.data.forEach(function (d) {
          if (d.name && d.value) {
            var v = typeof d.value === 'string' ? d.value.replace(/'/g, '&quot;') : d.value;
            extraProps["data-".concat(encodeURIComponent(d.name))] = v;
          }
        });
      }

      return extraProps;
    }
  }]);

  return DataComponent;
}(Component);

export { DataComponent as default };
DataComponent.propTypes = {
  data: PropTypes.array
};